<template>
  <div class="pb-6">
    <div class="d-flex justify-space-between align-center bg-orange-lighten-3 px-3 py-2 rounded-t shadowed mt-1">
      <div class="text-h6">Commande n°{{ commande.uuid }} - {{ $moment(commande.timestamp).format("DD/MM/YYYY à HH:mm") }}</div>
      <div class="text-body"></div>
      <div class="d-flex justify-center">
        <router-link :to="{ name: 'RefundCommande', params: { id_commande: commande.id } }">
          <v-btn style="background-color: white" variant="outlined" color="primary-dark">Effectuer un remboursement sur cette commande</v-btn>
        </router-link>
      </div>
    </div>

    <div class="bordered rounded-b bg-grey_1 mb-3 px-3 pb-3">
      <div class="d-flex gap mt-3">
        <InformationsPaiement :commande="commande"></InformationsPaiement>
        <ListTransactions v-if="commande.list_transactions.length > 0" :transactions="commande.list_transactions"></ListTransactions>
      </div>

      <div v-for="commande_inscriptions in commande.list_commandes_inscriptions_coureur" :key="commande_inscriptions.id">
        <v-sheet class="mt-3" border elevation="0">
          <div class="d-flex flex-column gap mt-1 pa-2">
            <InformationInscription v-for="inscription in commande_inscriptions.inscriptions" :inscription="inscription" type="refund" :key="inscription.id"></InformationInscription>
          </div>
          <div class="d-flex flex-column gap mt-1 pa-2" v-if="commande_inscriptions.list_commandes_options.length > 0">
            <InformationOptions :options="commande_inscriptions.list_commandes_options"></InformationOptions>
          </div>
          <div class="d-flex flex-column gap mt-1 pa-2" v-if="commande_inscriptions.gia">
            <InformationGIA :gia="commande_inscriptions.gia"></InformationGIA>
          </div>
          <div class="d-flex flex-column gap mt-1 pa-2" v-if="commande_inscriptions.donation">
            <InformationDonation :donation="commande_inscriptions.donation"></InformationDonation>
          </div>
          <div class="d-flex flex-column gap mt-1 pa-2" v-if="commande_inscriptions.code_reduction">
            <InformationCodeReduction :code_reduction="commande_inscriptions.code_reduction"></InformationCodeReduction>
          </div>
        </v-sheet>
      </div>
    </div>
  </div>
</template>

<script>
import InformationsPaiement from "../Explorer/Informations_Paiement.vue";
import ListTransactions from "../Explorer/List_Transactions.vue";
import InformationInscription from "../Explorer/Information_Inscription.vue";
import InformationOptions from "../Explorer/Informations_Options.vue";
import InformationGIA from "../Explorer/Informations_GIA.vue";
import InformationDonation from "../Explorer/Informations_Donation.vue";
import InformationCodeReduction from "../Explorer/Informations_Code_Reduction.vue";

export default {
  components: {
    InformationsPaiement,
    ListTransactions,
    InformationInscription,
    InformationOptions,
    InformationGIA,
    InformationDonation,
    InformationCodeReduction,
  },
  props: ["commande"],

  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
</style>